module.exports = __webpack_public_path__ + "static/media/dp-logo-text-centered-bg.52885911.png";